// van-search 输入框只能输入数字
import Vue from 'vue';

Vue.directive('inputNum', {
  inserted: function(el) {
    const input = el.querySelector('.van-field__control');
    input.onkeyup = function() {
      input.value = input.value.replace(/[^0-9]/g, '');
    };
    input.onblur = function() {
      input.value = input.value.replace(/[^0-9]/g, '');
    };
  }
});
